import MenuIcon from '../../../assets/icons/menu/menu.svg';
import AnouncementsIcon from '../../../assets/icons/menu/anouncements.svg';
import BankIcon from '../../../assets/icons/menu/bank.svg';
import DividendIcon from '../../../assets/icons/menu/dividend.svg';
import HoldingsIcon from '../../../assets/icons/menu/holdings.svg';
import MobileIcon from '../../../assets/icons/menu/mobile.svg';
import OrdersIcon from '../../../assets/icons/menu/orders.svg';
import PropertiesIcon from '../../../assets/icons/menu/properties.svg';
import SettingsIcon from '../../../assets/icons/menu/settings.svg';
import TradeIcon from '../../../assets/icons/menu/trade.svg';
import TransfersIcon from '../../../assets/icons/menu/transfers.svg';
import UsersIcon from '../../../assets/icons/menu/users.svg';
import WalletIcon from '../../../assets/icons/menu/wallet.svg';
import FeesIcon from '../../../assets/icons/menu/fees.svg';
import UsersListIcon from '../../../assets/icons/menu/user2.svg';
import AddUserIcon from '../../../assets/icons/menu/user_add.svg';
import MarketIcon from '../../../assets/icons/menu/market.svg';
import MenuCloseIcon from '../../../assets/icons/menu/menu_close.svg';
import MoneyWalletIcon from '../../../assets/icons/menu/money_wallet.svg';
import WalletEditIcon from '../../../assets/icons/menu/wallet_edit.svg';
import MarketAncIcon from '../../../assets/icons/menu/market_annoucement.svg';
import PropertyAncIcon from '../../../assets/icons/menu/property_announcement.svg';
import BuyIcon from '../../../assets/icons/menu/buy.svg';
import TransferIcon from '../../../assets/icons/menu/transfer.svg';
import TasksIcon from '../../../assets/icons/menu/tasks.svg';
import ListIcon from '../../../assets/icons/menu/list.svg';

export const useSideBarIcons = () => {
  const icons = {
    MenuIcon,
    AnouncementsIcon,
    BankIcon,
    DividendIcon,
    HoldingsIcon,
    MobileIcon,
    OrdersIcon,
    PropertiesIcon,
    SettingsIcon,
    TradeIcon,
    TransfersIcon,
    UsersIcon,
    WalletIcon,
    FeesIcon,
    UsersListIcon,
    AddUserIcon,
    MarketIcon,
    MenuCloseIcon,
    MoneyWalletIcon,
    WalletEditIcon,
    MarketAncIcon,
    PropertyAncIcon,
    //
    BuyIcon,
    TransferIcon,
    TasksIcon,
    ListIcon,
  };

  return icons;
};
